module.exports = __webpack_public_path__ + "img/banner.94052cc2.png";